import { render, staticRenderFns } from "./Jornal-eletronico.vue?vue&type=template&id=16938564&scoped=true"
import script from "./Jornal-eletronico.vue?vue&type=script&lang=js"
export * from "./Jornal-eletronico.vue?vue&type=script&lang=js"
import style0 from "./Jornal-eletronico.vue?vue&type=style&index=0&id=16938564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16938564",
  null
  
)

export default component.exports